<template>
  <div class="flex justify-between font-500">
    <div>
      <p>SHIPPING</p>
      <p class="text-neutral-500 uppercase">Estimated delivery {{ deliveryDate }} </p>
    </div>
    <div>
      {{ shipping }}
    </div>
  </div>
  <hr class="border-neutral-200 my-5"/>
</template>

<script setup lang="ts">

import {useCartStore} from "~/store/cart";
const { shipping } = storeToRefs(useCartStore())
const deliveryDate = computed(() => {
  const date = new Date()
  date.setDate(date.getDate() + 7)
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' })
})

</script>
